import Card from '../Cards/Card';
import CardGrid from '../Cards/CardGrid';
import Expander from '../Expander';

const CurrentPromotionsSection = ({ currentPromotions }) => (
  <div>
    <Expander
      summary="Current promotions"
      active
      details={
        <CardGrid currentPromo>
          {currentPromotions.map((promo) => {
            const { slug, id, name, imgUrls, startDate, endDate } = {
              ...promo,
            };
            return (
              <Card
                type="promotion"
                permalink={slug}
                id={id}
                key={id}
                name={name}
                banner={imgUrls?.landscapeBanner}
                startDate={startDate}
                endDate={endDate}
                buttonValue="Learn more"
              />
            );
          })}
        </CardGrid>
      }
    />
  </div>
);

export default CurrentPromotionsSection;
